import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useMember } from "../context/MemberAuthContext";

// Handles the Emergent Google OAuth return: {origin}/account#session_id=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setMember } = useMember();
  const processed = React.useRef(false);

  React.useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : "";
    (async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/member/session", {}, { headers: { "X-Session-ID": sessionId } });
        setMember(data);
      } catch (e) {
        console.error("Sign-in failed:", e);
        toast.error("We couldn't complete your sign-in. Please try again.");
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/account", { replace: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-cream" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-forest mx-auto mb-3" />
        <p className="text-ink-muted font-serif text-lg">Signing you in…</p>
      </div>
    </div>
  );
}
